import type { FieldValues, UseFormRegister } from 'react-hook-form';
import { useTabLabels } from '@/hooks/useTabLabels';
import { TrashCanIcon } from '@/icons/index';
import { StyledTextArea } from '@/Shared/StyledElements';

interface CourseSubsProps {
	courseFocusId: string;
	focusSkillId: string;
	skillId: string;
	skillText: string;
	skillType: string;
	isApprovalMode: boolean;
	canEdit: boolean;
	removeSkill: (skill: { [key: string]: string }) => void;
	register: UseFormRegister<FieldValues>;
	inputFocusRef: { current: boolean };
}

const CourseSubs = ({
	focusSkillId,
	skillId,
	canEdit,
	skillType,
	isApprovalMode,
	skillText,
	courseFocusId,
	removeSkill,
	register,
	inputFocusRef,
}: CourseSubsProps) => {
	const tabLabels = useTabLabels();
	const label = tabLabels[skillType] ?? tabLabels.skill;

	return (
		<div className="grid items-center gap-x-4 grid-cols-[1fr_auto] grid-rows-[auto_1fr] justify-items-start mb-4 ml-4 max-w-[800px]">
			{!isApprovalMode && (
				<>
					<span className="text-xs font-medium text-muted-foreground row-1 mb-1">{label}</span>
					<StyledTextArea
						className="row-2"
						readOnly={!canEdit || isApprovalMode}
						defaultValue={skillText}
						placeholder={label}
						{...register(`skill-${focusSkillId}-${skillId}`)}
						autoFocus={inputFocusRef.current}
					/>
					<input
						readOnly
						hidden
						defaultValue={skillType}
						{...register(`skill-${focusSkillId}-${skillId}-type`)}
					/>
					<input
						readOnly
						hidden
						value={JSON.stringify({
							focusSkillId,
							parentId: courseFocusId,
							skillText: `skill-${focusSkillId}-${skillId}`,
							skillType: `skill-${focusSkillId}-${skillId}-type`,
							skillId,
						})}
						{...register(`skillBlob-${skillId}-${focusSkillId}`)}
					/>
				</>
			)}
			{canEdit && !isApprovalMode && (
				<TrashCanIcon
					className="row-2"
					passedEvent={() =>
						removeSkill({
							focusSkillId,
							courseFocusId,
						})
					}
				/>
			)}
		</div>
	);
};

export default CourseSubs;
